module.exports = __webpack_public_path__ + "2c9d50f2a6b5bd51770344f73dd4b53f.png";